// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-body{
  font-size: 14px;
}

input.input-wider {
  width: 8em;
}

::ng-deep .wfm-modal .modal-body{
  min-width: 420px;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
